import { helpers, required } from '@vuelidate/validators'
import dayjs from 'dayjs'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'

dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)

export const rentalRoomEntryFormRules = {
  entry: {
    name: { required: requiredWithMessage('案件名') },
    periods: {
      required,
      $each: helpers.forEach({
        date: {
          required: requiredWithMessage('希望日'),
          uniquePeriodsValidation: {
            $validator: uniquePeriods,
            $message: '期間が重複しています'
          },
          timeValidation: {
            $validator: (value, siblings, vm) => {
              return siblings.endHour > siblings.startHour
            },
            $message: '時刻が不正です'
          }
        }
      })
    },
    firstDesignationType: {
      requiredIfUserExists: {
        $validator: (value, siblings, vm) => {
          return !(siblings.firstDesignationUser && !value)
        },
        $message: '指名理由は必須です'
      }
    },
    secondDesignationUser: {
      requireFirst: {
        $validator: (value, siblings, vm) => {
          return !(!siblings.firstDesignationUser && siblings.secondDesignationUser)
        },
        $message: '第一希望を先に選択してください'
      },
      notEqual: {
        $validator: (value, siblings, vm) => {
          if (!value) return true // 空同士の比較を回避
          return siblings.firstDesignationUser !== siblings.secondDesignationUser
        },
        $message: '同じエディターは選択できません'
      }
    },
    secondDesignationType: {
      requiredIfUserExists: {
        $validator: (value, siblings, vm) => {
          return !(siblings.secondDesignationUser && !value)
        },
        $message: '指名理由は必須です'
      }
    }
  }
}

function uniquePeriods (value, siblings, vm) {
  return !isPeriodOverlapping(vm.periods, siblings)
}

function requiredWithMessage (value) {
  return helpers.withMessage(`${value}を入力してください`, required)
}

function isPeriodOverlapping (periods, newPeriod) {
  // dayjsの日付オブジェクトに変換(24以上でもaddされるので問題ない)
  const newPeriodStart = dayjs(newPeriod.date)
    .startOf('date')
    .add(newPeriod.startHour, 'hours')
    .add(newPeriod.startMinute, 'minutes')
  const newPeriodEnd = dayjs(newPeriod.date)
    .startOf('date')
    .add(newPeriod.endHour, 'hours')
    .add(newPeriod.endMinute, 'minutes')

  // 既存の期間と比較
  for (const existingPeriod of periods.filter((p) => !(p.isPast || p.hasCancellationFee || p.isCanceled))) {
    // 自身と同じ期間は除外する
    if (existingPeriod === newPeriod || newPeriod.isPast || newPeriod.hasCancellationFee || newPeriod.isCanceled) {
      continue
    }

    const existingPeriodStart = dayjs(existingPeriod.date)
      .startOf('date')
      .add(existingPeriod.startHour, 'hours')
      .add(existingPeriod.startMinute, 'minutes')
    const existingPeriodEnd = dayjs(existingPeriod.date)
      .startOf('date')
      .add(existingPeriod.endHour, 'hours')
      .add(existingPeriod.endMinute, 'minutes')

    // 期間が重複している場合、trueを返す
    if (
      ((newPeriodStart.isSameOrBefore(existingPeriodEnd) &&
        newPeriodEnd.isSameOrAfter(existingPeriodStart)) ||
      (existingPeriodStart.isSameOrBefore(newPeriodEnd) &&
        existingPeriodEnd.isSameOrAfter(newPeriodStart))) &&
      existingPeriod.rentalRoomId === newPeriod.rentalRoomId
    ) {
      return true
    }
  }

  // 期間が重複していない場合、falseを返す
  return false
}
